const FLOATING_COLOR_SWATCHES = "floating-color-swatches";
const RESET_BUTTON = "reset-button";

export { FLOATING_COLOR_SWATCHES, RESET_BUTTON };
//# sourceMappingURL=data-hooks.js.map
